import { tsAnimal, tsSampledLine } from '../../../Typescript/DB_Interface'
import { DataGridPro, GridColDef, GridRowParams } from '@mui/x-data-grid-pro'
import { useNavigate } from 'react-router-dom'
import { v4 } from 'uuid'

function SampledContents({
  animals,
  lines,
  loading,
}: {
  animals: Partial<tsAnimal>[]
  lines: tsSampledLine[]
  loading: boolean
}) {
  const navigate = useNavigate()
  let data: any[] = []
  let columns: GridColDef[] = []
  let getRowID: any
  let onRowClick: ({ row }: GridRowParams) => any = () => undefined
  if (lines.length > 0) {
    data = lines
    getRowID = (row: tsSampledLine) => `${row.RackID}-${row.ShortLineName}`
    columns = [
      {
        field: 'RackID',
        headerName: 'Rack ID',
        flex: 1,
      },
      {
        field: 'ShortLineName',
        headerName: 'Short Line Name',
        flex: 2,
      },
    ]
  } else {
    data = animals
    getRowID = (row: tsAnimal) => row.AnimalID ?? v4()
    onRowClick = ({ row }: GridRowParams) =>
      navigate({
        pathname: '/stuart/sample/animal/' + row?.UAI,
      })
    columns = [
      {
        field: 'AnimalID',
        headerName: 'Animal ID',
        flex: 1,
      },
      {
        field: 'ShortLineName',
        headerName: 'Short Line Name',
        flex: 2,
      },
      {
        field: 'UAI',
        headerName: 'UAI',
        flex: 1,
      },
    ]
  }

  return (
    <DataGridPro
      sx={{ width: 1 }}
      rows={data}
      columns={columns}
      getRowId={getRowID}
      disableColumnMenu
      autoHeight
      hideFooter
      density={'compact'}
      onRowClick={onRowClick}
      loading={loading}
    />
  )
}

export default SampledContents
